export default () => ({
    data: {},
    wishlist: null,
    popupCart: {
        lastItem: null,
    },
    thirdParty: null,
})
